// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_updateMarketingProfileMemberInfo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "MarketingProfileMemberInfoUpdated",
    "ProfileSettingsChangedError"
  ]);
}

let variablesConverter = {"updateMarketingProfileMemberInfoInput":{"bio":{"b":""}},"__root":{"input":{"r":"updateMarketingProfileMemberInfoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"updateMarketingProfileMemberInfo_MarketingProfileMemberInfoUpdated_member":{"f":""},"updateMarketingProfileMemberInfo":{"u":"response_updateMarketingProfileMemberInfo"}}};

let wrapResponseConverterMap = {
  response_updateMarketingProfileMemberInfo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"updateMarketingProfileMemberInfo_MarketingProfileMemberInfoUpdated_member":{"f":""},"updateMarketingProfileMemberInfo":{"u":"response_updateMarketingProfileMemberInfo"}}};

let responseConverterMap = {
  response_updateMarketingProfileMemberInfo: unwrap_response_updateMarketingProfileMemberInfo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "settingsChangedMessage",
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "ProfileSettingsChangedError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMarketingProfileMemberInfoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "EditMarketingProfileMemberInfoForm_marketingProfileMember"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberInfoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMarketingProfileMemberInfoFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateMarketingProfileMemberInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MarketingProfileMember",
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "licenseNumber",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "nodeId",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "MarketingProfileMemberInfoUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eedea84516c55ac209863b8195895395",
    "id": null,
    "metadata": {},
    "name": "EditMarketingProfileMemberInfoFormMutation",
    "operationKind": "mutation",
    "text": "mutation EditMarketingProfileMemberInfoFormMutation(\n  $input: UpdateMarketingProfileMemberInfoInput!\n) {\n  updateMarketingProfileMemberInfo(input: $input) {\n    __typename\n    ... on ProfileSettingsChangedError {\n      settingsChangedMessage: message\n    }\n    ... on MarketingProfileMemberInfoUpdated {\n      member {\n        ...EditMarketingProfileMemberInfoForm_marketingProfileMember\n        nodeId\n      }\n    }\n  }\n}\n\nfragment EditMarketingProfileMemberInfoForm_marketingProfileMember on MarketingProfileMember {\n  firstName\n  lastName\n  licenseNumber\n  title\n  bio\n  id\n}\n"
  }
};
})());

let wrap_response_updateMarketingProfileMemberInfo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateMarketingProfileMemberInfo = unwrap_response_updateMarketingProfileMemberInfo;
exports.wrap_response_updateMarketingProfileMemberInfo = wrap_response_updateMarketingProfileMemberInfo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
